import {createAction} from 'web-app/util/redux/typed-action-helpers';

export const {action: reset} = createAction('ACCIDENT_INCIDENT_CHILD_PROFILE', () => ({}));
